var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkResource(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 12,
    viewBox: "0 0 13 12",
    width: 13,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.667 1.333a.667.667 0 110-1.333h4a.667.667 0 01.666.667v4a.666.666 0 11-1.333 0V2.276L4.805 8.471a.667.667 0 01-.943-.942l6.196-6.196zM.333 2.667a1.333 1.333 0 011.334-1.334H5a.667.667 0 010 1.334H1.667v8h8V7.333a.667.667 0 011.333 0v3.334A1.333 1.333 0 019.667 12h-8a1.334 1.334 0 01-1.334-1.333z",
    fill: "#005ce6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkResource);
export default __webpack_public_path__ + "static/media/link_resource.f5a472115860f473c7fcfaa4add3f91c.svg";
export { ForwardRef as ReactComponent };